import {
  createItem,
  readItems,
  updateItem,
  aggregate,
  deleteItems,
} from "@directus/sdk";
import { getDirectusClient } from "../lib/directus";

const directus = getDirectusClient();
export const CreateInventarioNoSerial = async (data) => {
  try {
    const response = await directus.request(
      createItem("inventario_no_serial", {
        ...data,
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const EditInventarioNoSerial = async (id, data) => {
  try {
    const response = await directus.request(
      updateItem("inventario_no_serial", id, data)
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getInventarioNoSerial = async (userRoleID, userBodega) => {
  try {
    const response = await directus.request(
      readItems("inventario_no_serial", {
        fields: [
          "nombre",
          "producto.grupo.impuesto",
          "id",
          "cantidad",
          "producto.preciosinimp",
          "producto.nombre",
          "producto.id",
        ],
        filter: {
          ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
            ? {
                producto: {
                  bodega: {
                    id: { _eq: userBodega },
                  },
                },
              }
            : {}),
        },
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getInventarioNoSerialCount = async () => {
  try {
    const response = await directus.request(
      aggregate("inventario_no_serial", {
        aggregate: {
          countDistinct: ["*"],
        },
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getInventarioNoSerialByProducto = async (nombre) => {
  try {
    const response = await directus.request(
      readItems("inventario_no_serial", {
        fields: ["*.*", "producto.grupo.impuesto"],
        filter: {
          _and: [
            {
              producto: {
                nombre: {
                  _contains: nombre,
                },
              },
            },
          ],
        },
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getInventarioNoSerialByGrupo = async (nombre) => {
  try {
    const response = await directus.request(
      readItems("inventario_no_serial", {
        fields: ["*.*", "producto.grupo.impuesto"],
        filter: {
          _and: [
            {
              producto: {
                grupo: {
                  nombre: {
                    _contains: nombre,
                  },
                },
              },
            },
          ],
        },
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getInventarioNoSerialById = async (id) => {
  try {
    const response = await directus.request(
      readItems("inventario_no_serial", {
        fields: ["*.*", "producto.grupo.impuesto"],
        filter: {
          _and: [
            {
              id: {
                _eq: id,
              },
            },
          ],
        },
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const DeleteInventarioNoSerialByOrder = async (orderId, productId) => {
  try {
    const directus = await getDirectusClient();

    const inventarioNoSerial = await directus.request(
      readItems("inventario_no_serial", {
        fields: ["id", "cantidad", "producto.id"],
        filter: {
          producto: {
            id: { _eq: productId },
          },
        },
      })
    );

    if (inventarioNoSerial && inventarioNoSerial.length > 0) {
      const inventario = inventarioNoSerial[0];

      const cantidadARestar = await getCantidadAgregadaPorOrden(
        orderId,
        productId
      );
      const nuevaCantidad = Math.max(
        0,
        Number(inventario.cantidad) - cantidadARestar
      );

      await directus.request(
        updateItem("inventario_no_serial", inventario.id, {
          cantidad: nuevaCantidad,
        })
      );

      return { success: true, nuevaCantidad };
    }

    return {
      success: false,
      message: "No se encontró inventario para el producto",
    };
  } catch (error) {
    throw error;
  }
};

const getCantidadAgregadaPorOrden = async (orderId, productId) => {
  try {
    const directus = await getDirectusClient();

    const orden = await directus.request(
      readItems("ordenes_decompra", {
        fields: ["productos.id", "productos.ingresado_no_serial"],
        filter: {
          id: { _eq: orderId },
        },
      })
    );

    if (orden && orden.length > 0 && orden[0].productos) {
      const producto = orden[0].productos.find((p) => p.id === productId);
      return Number(producto?.ingresado_no_serial || 0);
    }

    return 0;
  } catch (error) {
    console.error("Error obteniendo cantidad agregada:", error);
    return 0;
  }
};
